
import mixin from '../mixins/index'
export default {
  mixins: [mixin],
}
